import { useQuery } from '@tanstack/react-query';
import restClient from '../common/api/restClient';

export const useChallengeNames = (status) => {
  const prefix = process.env.REACT_APP_PROXY_PREFIX || '';
  return useQuery({
    queryKey: ['challengeNames', status],
    queryFn: async () => {
      const url = status 
        ? `${prefix}/results/challenge-names?status=${status}`
        : `${prefix}/results/challenge-names`;
      
      const response = await restClient({
        url,
        method: 'get'
      });
      
      return response;
    },
    staleTime: 0, 
    cacheTime:0
  });
};
